module.exports = __webpack_public_path__ + "img/edit.8672c20d.svg";